import BoneFracture from "./BoneFracture";
import OrthopaedicClinic from "./OrthopaedicClinic";
import OrthopaedicConsultation from "./OrthopaedicConsultation";
import OrthopaedicEvaluation from "./OrthopaedicEvaluation";
import TreatmentPlanning from "./TreatmentPlanning";
import FractureTraumaCare from "./FractureTraumaCare";
import PlasterCasting from "./PlasterCasting";
import SportMedicine from "./SportMedicine";
import SportsInjury from "./SportsInjury";
import LigamentInjuries from "./LigamentInjuries";
import TendonMuscleInjuries from "./TendonMuscleInjuries";
import ReturnToSport from "./ReturnToSport";
import ArthroscopicAcl from "./ArthroscopicAcl";
import ArthroscopicShoulder from "./ArthroscopicShoulder";
import Arthroscopy from "./Arthroscopy";
import ArthritisJointPain from "./ArthritisJointPain";
import JointReplacement from "./JointReplacement";
import BackPain from "./BackPain";
import BackSpineCare from "./BackSpineCare";
import PaediatricOrthopaedics from "./PaediatricOrthopaedics";
import CongenitalOrtho from "./CongenitalOrtho";
import PainManagement from "./PainManagement";
import JointInjections from "./JointInjections";
import PrpTherapy from "./PrpTherapy";
import Rehabilitation from "./Rehabilitation";
import PostOpRehab from "./PostOpRehab";
import MobilityExercises from "./MobilityExercises";
import KneeAndHip from "./KneeAndHip";
import DiabeticWound from "./DiabeticWound";
import Highintensity from "./Highintensity";
import Laboratory from "./Laboratory";
import Wounddressing from "./Wounddressing";
import GeneralObstetrics from "./GeneralObstetrics";
import HighRiskObstetric from "./HighRiskObstetric";
import PIH from "./PIH";
import APH from "./APH";
import PPH from "./PPH";
import EctopicPregnancy from "./EctopicPregnancy";
import PreEclampsia from "./PreEclampsia";
import InevitableAbortion from "./InevitableAbortion";
import Respiratory from "./Respiratory";
import OrthopedicProblem from "./OrthopedicProblem";
import InfectionsDisease from "./InfectionsDisease";
import Hysterectomy from "./Hysterectomy";

const Subjectservice=
[
    {
        name:"Orthopaedic Clinic",
        bannerimg:"orthopedicbanner",
        bannername:"Orthopaedic Clinic",
        service:<OrthopaedicClinic/>,
    },
    {
        name:"Orthopaedic Consultation",
        bannerimg:"orthopedicbanner",
        bannername:"Orthopaedic Consultation",
        service:<OrthopaedicConsultation/>,
    },
    {
        name:"Evaluation and Diagnosis of Bone, Joint, Muscle and Ligament Problems",
        bannerimg:"orthopedicbanner",
        bannername:"Evaluation and Diagnosis of Bone, Joint, Muscle and Ligament Problems",
        service:<OrthopaedicEvaluation/>,
    },
    {
        name:"Personalized Treatment Planning",
        bannerimg:"orthopedicbanner",
        bannername:"Personalized Treatment Planning",
        service:<TreatmentPlanning/>,
    },
    {
        name:"Bone Fracture Treatment Surgical And Conservative Treatment",
        bannerimg:"orthopedicbanner",
        bannername:"Bone Fracture Treatment Surgical And Conservative Treatment",
        service:<BoneFracture/>,
    },
    {
        name:"Fracture & Trauma Care",
        bannerimg:"orthopedicbanner",
        bannername:"Fracture & Trauma Care",
        service:<FractureTraumaCare/>,
    },
    {
        name:"Plaster Casting, Splinting and Follow-up Care",
        bannerimg:"orthopedicbanner",
        bannername:"Plaster Casting, Splinting and Follow-up Care",
        service:<PlasterCasting/>,
    },
    {
        name:"Sport Medicine",
        bannerimg:"orthopedicbanner",
        bannername:"Sport Medicine",
        service:<SportMedicine/>,
    },
    {
        name:"Sports Injury Management",
        bannerimg:"orthopedicbanner",
        bannername:"Sports Injury Management",
        service:<SportsInjury/>,
    },
    {
        name:"Ligament Injuries (ACL, PCL, Meniscus)",
        bannerimg:"orthopedicbanner",
        bannername:"Ligament Injuries (ACL, PCL, Meniscus)",
        service:<LigamentInjuries/>,
    },
    {
        name:"Tendon Injuries and Muscle Strains",
        bannerimg:"orthopedicbanner",
        bannername:"Tendon Injuries and Muscle Strains",
        service:<TendonMuscleInjuries/>,
    },
    {
        name:"Return-to-Sport Rehabilitation",
        bannerimg:"orthopedicbanner",
        bannername:"Return-to-Sport Rehabilitation",
        service:<ReturnToSport/>,
    },
    {
        name:"Arthroscopic Acl Andmenicus Repair Reconstruction",
        bannerimg:"orthopedicbanner",
        bannername:"Arthroscopic Acl Andmenicus Repair Reconstruction",
        service:<ArthroscopicAcl/>
    },
    {
        name:"Arthroscopic Shoulder Surgeries",
        bannerimg:"orthopedicbanner",
        bannername:"Arthroscopic Shoulder Surgeries",
        service:<ArthroscopicShoulder/>
    },
    {
        name:"Arthroscopy (Keyhole Surgery)",
        bannerimg:"orthopedicbanner",
        bannername:"Arthroscopy (Keyhole Surgery)",
        service:<Arthroscopy/>
    },
    {
        name:"Arthritis & Joint Pain Management",
        bannerimg:"orthopedicbanner",
        bannername:"Arthritis & Joint Pain Management",
        service:<ArthritisJointPain/>
    },
    {
        name:"Joint Replacement Services",
        bannerimg:"orthopedicbanner",
        bannername:"Joint Replacement Services",
        service:<JointReplacement/>
    },
    {
        name:"Back Pain And Disc Related Diseases Treatment",
        bannerimg:"orthopedicbanner",
        bannername:"Back Pain And Disc Related Diseases Treatment",
        service:<BackPain/>
    },
    {
        name:"Back & Spine Care",
        bannerimg:"orthopedicbanner",
        bannername:"Back & Spine Care",
        service:<BackSpineCare/>
    },
    {
        name:"Paediatric Orthopaedics",
        bannerimg:"orthopedicbanner",
        bannername:"Paediatric Orthopaedics",
        service:<PaediatricOrthopaedics/>
    },
    {
        name:"Congenital Deformities & Growth Related Issues",
        bannerimg:"orthopedicbanner",
        bannername:"Congenital Deformities & Growth Related Issues",
        service:<CongenitalOrtho/>
    },
    {
        name:"Pain Management Procedures",
        bannerimg:"orthopedicbanner",
        bannername:"Pain Management Procedures",
        service:<PainManagement/>
    },
    {
        name:"Joint Injections",
        bannerimg:"orthopedicbanner",
        bannername:"Joint Injections",
        service:<JointInjections/>
    },
    {
        name:"PRP and Non-Surgical Pain Relief Options",
        bannerimg:"orthopedicbanner",
        bannername:"PRP and Non-Surgical Pain Relief Options",
        service:<PrpTherapy/>
    },
    {
        name:"Rehabilitation & Physiotherapy Guidance",
        bannerimg:"orthopedicbanner",
        bannername:"Rehabilitation & Physiotherapy Guidance",
        service:<Rehabilitation/>
    },
    {
        name:"Post-Operative Rehabilitation Protocols",
        bannerimg:"orthopedicbanner",
        bannername:"Post-Operative Rehabilitation Protocols",
        service:<PostOpRehab/>
    },
    {
        name:"Strengthening and Mobility Exercises",
        bannerimg:"orthopedicbanner",
        bannername:"Strengthening and Mobility Exercises",
        service:<MobilityExercises/>
    },
    {
        name:"Knee And Hip Replacement Surgery Primary And Revision",
        bannerimg:"orthopedicbanner",
        bannername:"Knee And Hip Replacement Surgery Primary And Revision",
        service:<KneeAndHip/>
    },
    {
        name:"Diabetic Wound Dressing And Management",
        bannerimg:"orthopedicbanner",
        bannername:"Diabetic Wound Dressing And Management",
        service:<DiabeticWound/>
    },
    {
        name:"General Obstetrics",
        bannerimg:"obgsbanner",
        bannername:"General Obstetrics",
        service:<GeneralObstetrics/>,
    },
    {
        name:"High Risk Obstetric Cases",
        bannerimg:"obgsbanner",
        bannername:"High Risk Obstetric Cases",
        service:<HighRiskObstetric/>
    },
    {
        name:"PIH(Pregnancy Induced Hypertension)",
        bannerimg:"obgsbanner",
        bannername:"PIH(Pregnancy Induced Hypertension)",
        service:<PIH/>
    },
    {
        name:"APH(Antepartum Haemorrhage)",
        bannerimg:"obgsbanner",
        bannername:"APH(Antepartum Haemorrhage)",
        service:<APH/>
    },
    {
        name:"PPH(Postpartum Haemorrhage)",
        bannerimg:"obgsbanner",
        bannername:"PPH(Postpartum Haemorrhage)",
        service:<PPH/>
    },
    {
        name:"Ectopic Pregnancy",
        bannerimg:"obgsbanner",
        bannername:"Ectopic Pregnancy",
        service:<EctopicPregnancy/>
    },
    {
        name:"Pre-Eclampsia",
        bannerimg:"obgsbanner",
        bannername:"Pre-Eclampsia",
        service:<PreEclampsia/>
    },
    {
        name:"Inevitable Abortion",
        bannerimg:"obgsbanner",
        bannername:"Inevitable Abortion",
        service:<InevitableAbortion/>
    },
    {
        name:"Respiratory Problems With Pregnancy",
        bannerimg:"obgsbanner",
        bannername:"Respiratory Problems With Pregnancy",
        service:<Respiratory/>
    },
    {
        name:"Orthopedic Problem With Pregnancy",
        bannerimg:"obgsbanner",
        bannername:"Orthopedic Problem With Pregnancy",
        service:<OrthopedicProblem/>
    },
    {
        name:"Infections Disease",
        bannerimg:"obgsbanner",
        bannername:"Infections Disease",
        service:<InfectionsDisease/>
    },
    {
        name:"Hysterectomy",
        bannerimg:"obgsbanner",
        bannername:"Hysterectomy",
        service:<Hysterectomy/>
    },
    {
        name:"High intensity digital xray",
        bannerimg:"clinicbanner",
        bannername:"High intensity digital xray",
        service:<Highintensity/>
    },
    {
        name:"Laboratory blood collection centre",
        bannerimg:"clinicbanner",
        bannername:"Laboratory blood collection centre",
        service:<Laboratory/>
    },
    {
        name:"Wound dressing",
        bannerimg:"clinicbanner",
        bannername:"Wound dressing",
        service:<Wounddressing/>
    },
]
export default Subjectservice;
